import { getToken, Messaging } from 'firebase/messaging';
import { useEffect } from 'react';
import { fbKey } from '../../../helpers/local-storage';
import { swPath } from '../../../helpers/path';
import { getPushState, getSwState } from '../../../helpers/validate';
import { useLang } from '../../../hooks/use-lang';
import { useLocalStorageSubscribe } from '../../../hooks/use-local-storage-subscribe';
import { fetchCompanyProfile } from '../../../store/api/company-api';
import { useAlertStore } from '../../../store/use-alert-store';

interface FirebaseMessagingProps {
  firebaseMessaging: Messaging;
}

export const useFirebaseRegister = ({ firebaseMessaging }: FirebaseMessagingProps) => {
  const { add } = useAlertStore();
  const { t } = useLang();

  useLocalStorageSubscribe();

  useEffect(() => {
    const registerFirebaseMessaging = async () => {
      const registration = await navigator.serviceWorker.getRegistration(swPath);

      try {
        const token = await getToken(firebaseMessaging, {
          vapidKey:
            'BDaSQlZa6H8Gj4XI0_PbxQaKjWOJXyLKpJQanbK9tOJuNiz3H7Yl9lxM3VlfVtUDSiXXeKM9L4IKpC5u8Q0zgaA',
          serviceWorkerRegistration: registration, // Передаем регистрацию Service Worker
        });
        const isNewToken = localStorage.getItem(fbKey) !== token;

        if (token) {
          if (!isNewToken) return;
          localStorage.setItem(fbKey, token);
          await fetchCompanyProfile(); // для записи токена в БД
          add({ label: t('Уведомления активны'), variant: 'info' });
        } else {
          console.error('No registration token available. Request permission to generate one.');
        }
      } catch (error) {
        console.error('Error getting token:', error);
      }
    };

    const checkServiceWorker = setInterval(async () => {
      const isReady = (await getSwState()) && getPushState();
      if (!isReady) return;
      await registerFirebaseMessaging().then(() => clearInterval(checkServiceWorker));
    }, 10000);

    return () => {
      clearInterval(checkServiceWorker);
    };
  }, []);
};
